/**
 *
 * StepOne
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {
  makeSelectClientDetails,
  makeSelectInsuranceModal,
  makeSelectInsuranceOptions,
} from 'containers/Main/selectors';
import useSiteCopySelector from 'components/useSiteCopySelector';
import { getTokenFriendlyType } from 'components/ResourceItemSelector/utils';
import Dropdown from './Dropdown';

const useStyles = makeStyles(theme => ({
  body: {
    padding: '12px 80px 0',
    [theme.breakpoints.down('xs')]: {
      padding: '12px 12px 0',
    },
  },
  button: {
    ...theme.typography.button,
    color: '#fff',
    boxShadow: 'none',
    width: 139,
    height: 50,
    borderRadius: 2,
    '&:hover': {
      backgroundColor: theme.palette.primary.secondary,
      opacity: 0.8,
    },
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  logo: {
    width: 135,
    marginBottom: 28,
  },
  dropdownWrapper: {
    marginTop: 18,
    display: 'flex',
    justifyContent: 'center',
  },
  buttonWrapper: {
    marginTop: 28,
    display: 'flex',
    justifyContent: 'center',
  },
  skipWrapper: {
    position: 'absolute',
    bottom: 24,
    left: 32,
    right: 32,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  skipButton: {
    ...theme.typography.body2,
    color: theme.palette.primary.main,
    height: 28,
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

const StepOne = ({ error, insurance, onClose, onInsuranceChange, onNext }) => {
  const classes = useStyles();
  const clientDetails = useSelector(makeSelectClientDetails());
  const status = useSelector(makeSelectInsuranceModal());
  const insuranceOptions = useSelector(makeSelectInsuranceOptions());
  const [siteCopy] = useSiteCopySelector(['insurance-modal']);

  const header = _get(
    siteCopy,
    ['pageCopy', 'page1', 'header', status.type],
    '',
  ).replace('#type', getTokenFriendlyType(status.resourceType));

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} className={classes.logoWrapper}>
        <img
          src={_get(clientDetails, 'crediblemindLogo.url', '')}
          className={classes.logo}
          alt={_get(clientDetails, 'formalShortName')}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4" color="primary" align="center">
          {header}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.body}>
        <Typography variant="body2" color="textPrimary" align="center">
          {_get(siteCopy, 'pageCopy.page1.description', '')}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.dropdownWrapper}>
        <Dropdown
          error={error}
          value={insurance}
          options={insuranceOptions}
          onChange={onInsuranceChange}
        />
      </Grid>
      <Grid item xs={12} className={classes.buttonWrapper}>
        <Button
          variant="contained"
          disabled={insurance === -1}
          className={classes.button}
          onClick={onNext}
          color="secondary"
        >
          {_get(siteCopy, 'pageCopy.page1.button', '')}
        </Button>
      </Grid>
      {_get(siteCopy, 'pageCopy.page1.skipButton', '') && (
        <Grid item xs={12} className={classes.skipWrapper}>
          <ButtonBase className={classes.skipButton} onClick={onClose}>
            {_get(siteCopy, 'pageCopy.page1.skipButton', '')}
          </ButtonBase>
        </Grid>
      )}
    </Grid>
  );
};

StepOne.propTypes = {
  insurance: PropTypes.string,
  onClose: PropTypes.func,
  onInsuranceChange: PropTypes.func,
  onNext: PropTypes.func,
};

export default StepOne;
